import { API_URL } from 'config'
import { logout, authHeader } from 'utils/authenticationService'
import camelcase from 'camelcase-keys'
import snakecase from 'snakecase-keys'
import { HTTPError } from './HTTPError'

const fetchWrapper = async (url: string, options: RequestInit) => {
  const fullUrl = url.match(/^http(s)?:\/\//) ? url : `${API_URL}${url}`
  const response = await fetch(fullUrl, options)
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      logout()
    }

    if (response.status === 422) {
      try {
        const error = await response.json()
        throw new HTTPError(response.status, response.statusText, error)
      } catch {
        throw new HTTPError(response.status, response.statusText)
      }
    } else {
      throw new HTTPError(response.status, response.statusText)
    }
  }

  const data = await response.json()
  return camelcase(data, { deep: true })
}

export async function get<T>(
  url: string,
  fetchOptions?: RequestInit
): Promise<T> {
  return fetchWrapper(url, {
    method: 'GET',
    headers: {
      Pragma: 'no-cache' /* Fix IE11 caching API responses */,
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    ...fetchOptions,
  })
}

export async function post<T>(
  url: string,
  params: any,
  fetchOptions?: RequestInit
): Promise<T> {
  return fetchWrapper(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(snakecase(params, { deep: true })),
    ...fetchOptions,
  })
}

export const encodeUrlParams = (endpoint: string, params: any) => {
  const url = new URL(`${API_URL}${endpoint}`)
  const snakeParams = snakecase(params)
  Object.entries(snakeParams).forEach(([key, value]) => {
    if (key && value) {
      // @ts-ignore
      url.searchParams.append(key, value)
    }
  })

  return decodeURIComponent(url.toString())
}
